<template>
  <!-- 移交阶段 -->
    <div class="bid-box transfer">
        <table class="layui-table" v-if="unitKind=='1'">
            <colgroup>
                <col width="150">
                <col width="200">
                <col width="200">
                <col width="120">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="2">移交阶段</td>
                    <td>实物、竣工资料移交时间以及移交表</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in accept.materialobjectInfo.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                v-else
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled>
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd1" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex1==index" class="el-icon-delete ctl" @click="delList1(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>档案移交</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit"  v-model="accept.conproArchive.flag">无</el-checkbox>
                        <el-checkbox v-else  disabled v-model="accept.conproArchive.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.conproArchive.flag">
                            <div v-for="(item,index) in accept.conproArchive.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit"  type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td rowspan="4">决算阶段</td>
                    <td>跟踪审计价款及报告</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.auditPrice.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="final.auditPrice.flag" disabled>无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.auditPrice.flag">
                            <div v-for="(item,index) in final.auditPrice.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex7='-1'" @mouseenter="delIndex7=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    >
                                </el-date-picker>
                                <span style="margin-left:1vw;line-height: 4vh;">审计价款：</span>
                                <el-input v-if="edit" v-model="item.start" placeholder="" style="width:5vw;" ></el-input>
                                <el-input v-else v-model="item.start" placeholder="" style="width:5vw;" disabled></el-input>
                                <span  style="margin-right:2vw;padding-left:5px;line-height: 4vh;">万元</span>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess4"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAuditPrice" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex7==index" class="el-icon-delete ctl" @click="delAuditPrice(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>送审审计价款及报告</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.firstAccountinfo.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="final.firstAccountinfo.flag" disabled>无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.firstAccountinfo.flag">
                            <div v-for="(item,index) in final.firstAccountinfo.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex4='-1'" @mouseenter="delIndex4=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    >
                                </el-date-picker>
                                <span style="margin-left:1vw;line-height: 4vh;">送审价款：</span>
                                <el-input v-if="edit" v-model="item.start" placeholder="" style="width:5vw;" @blur="setFirstTotal"></el-input>
                                <el-input v-else v-model="item.start" placeholder="" style="width:5vw;" @blur="setFirstTotal" disabled></el-input>
                                <span  style="margin-right:2vw;padding-left:5px;line-height: 4vh;">万元</span>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess5"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFirstAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex4==index" class="el-icon-delete ctl" @click="delFirstAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>终审审计价款及报告</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in final.finalAccountinfo.list" :key="index" style="display:flex;;" :style="index!=1?'margin-top:2vh':''" @mouseleave="delIndex5='-1'" @mouseenter="delIndex5=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.endTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else
                                    v-model="item.endTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    >
                                </el-date-picker>
                                <span style="margin-left:1vw;line-height: 4vh;">终审价款：	</span>
                                <el-input v-if="edit"  v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal"></el-input>
                                <el-input v-else v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal" disabled></el-input>
                                <span style="margin-right:2vw;padding-left:5px;line-height: 4vh;">万元</span>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess6"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button  v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toFinalAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex5==index" class="el-icon-delete ctl" @click="delFinalAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.otherFile.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="final.otherFile.flag" disabled>无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.otherFile.flag">
                            <div v-for="(item,index) in final.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex6='-1'" @mouseenter="delIndex6=index">
                                <el-input  v-if="edit" v-model="item.name" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input  v-else   v-model="item.name" placeholder="" style="margin-right:1vw;" disabled></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess7"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddOtherFile" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex6==index" class="el-icon-delete ctl" @click="delOtherFile(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <table class="layui-table" v-if="unitKind=='2'">
            <colgroup>
                <col width="150">
                <col width="200">
                <col width="200">
                <col width="120">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="2">移交阶段</td>
                    <td>实物、竣工资料移交时间以及移交表</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in accept.materialobjectInfo.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                v-else
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled>
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd1" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex1==index" class="el-icon-delete ctl" @click="delList1(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>档案移交</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit"  v-model="accept.conproArchive.flag">无</el-checkbox>
                        <el-checkbox v-else  disabled v-model="accept.conproArchive.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.conproArchive.flag">
                            <div v-for="(item,index) in accept.conproArchive.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit"  type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td rowspan="2">决算阶段</td>
                    <td>终审审计价款及报告</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in final.finalAccountinfo.list" :key="index" style="display:flex;;" :style="index!=1?'margin-top:2vh':''" @mouseleave="delIndex5='-1'" @mouseenter="delIndex5=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.endTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else
                                    v-model="item.endTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    >
                                </el-date-picker>
                                <span style="margin-left:1vw;line-height: 4vh;">终审价款：	</span>
                                <el-input v-if="edit"  v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal"></el-input>
                                <el-input v-else v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal" disabled></el-input>
                                <span style="margin-right:2vw;padding-left:5px;line-height: 4vh;">万元</span>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess6"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button  v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toFinalAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex5==index" class="el-icon-delete ctl" @click="delFinalAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.otherFile.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="final.otherFile.flag" disabled>无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.otherFile.flag">
                            <div v-for="(item,index) in final.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex6='-1'" @mouseenter="delIndex6=index">
                                <el-input  v-if="edit" v-model="item.name" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input  v-else   v-model="item.name" placeholder="" style="margin-right:1vw;" disabled></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess7"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddOtherFile" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex6==index" class="el-icon-delete ctl" @click="delOtherFile(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onFinalSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div>



        <!-- <el-form ref="form" :model="form" label-width="300px">
            <el-form-item label="所属合同：">
                <span style="color:#296dd3;">{{agreeName}}</span>
            </el-form-item>

            <el-form-item label="建设工程档案移交书(技术处)：">
                <el-checkbox v-if="edit"  v-model="accept.conproArchive.flag">无</el-checkbox>
                 <el-checkbox v-else  disabled v-model="accept.conproArchive.flag">无</el-checkbox>
                <div v-if="!accept.conproArchive.flag">
                    <div v-for="(item,index) in accept.conproArchive.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess"
                            :on-remove="handleDel"
                            :on-preview="showFile"
                            style="margin-left:1vw;"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit"  type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="实物移交时间以及移交表：">
                <div>
                    <div v-for="(item,index) in accept.materialobjectInfo.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.time"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                         <el-date-picker
                           v-else
                            v-model="item.time"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled>
                        </el-date-picker>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            style="margin-left:1vw;"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd1" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex1==index" class="el-icon-delete ctl" @click="delList1(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="国资移交时间及移交表：">
                <div>
                    <div v-for="(item,index) in accept.wordTrade.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex2='-1'" @mouseenter="delIndex2=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.time"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker
                            v-else
                            v-model="item.time"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled>
                        </el-date-picker>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess2"
                            :on-remove="handleDel2"
                            :on-preview="showFile"
                            style="margin-left:1vw;"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd2" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex2==index" class="el-icon-delete ctl" @click="delList2(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="其他：">
                <el-checkbox v-if="edit" v-model="accept.otherFile.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="accept.otherFile.flag">无</el-checkbox>
                <div v-if="!accept.otherFile.flag">
                    <div v-for="(item,index) in accept.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-input v-if="edit" v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-input v-else disabled v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess3"
                            :on-remove="handleDel3"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd3" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delList3(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item v-if="edit">
                <el-button type="primary" @click="onFinalSubmit">保存</el-button>
                <el-button>返回</el-button>
            </el-form-item>
        </el-form> -->
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            agreeName:'',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            form:{},
            accept:{  //
                conproArchive:{ //建设工程档案移交书(技术处)
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                materialobjectInfo:{ //实物移交时间以及移交表
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                wordTrade:{  //国贸移交时间及移交表
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                otherFile:{  //其他
                    flag:false,
                    list:[
                        {index:1,val:'',files:[]},
                    ],
                },
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex2:'-1',
            delIndex3:'-1',
            delIndex4:'-1',
            delIndex5:'-1',
            delIndex6:'-1',
            delIndex7:'-1',
            status:'',
            unitKind:'',
            edit:false,
            //决算阶段
            final:{  //
                firstAccountinfo:{ //初审决算价款及报告
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',end:'',entTime:'',files:[]},
                    ],
                },
                firstAll:{
                    start:0,
                    end:0
                },
                auditPrice:{
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',end:'',entTime:'',files:[]},
                    ],
                },
                finalAccountinfo:{
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',end:'',entTime:'',files:[]},
                    ],
                },
                finalAll:{
                    start:0,
                    end:0
                },
                otherFile:{
                    flag:false,
                    list:[
                        {name:'',files:[],index:1,} //index 用于区分list
                    ],
                },
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.status = params.status
        this.getInfo()
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        console.log(this.edit)
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.getData()
                }
            })
        },
        //获取阶段信息
        getData(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var item in that.accept){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.accept[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.accept[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.accept[item] = data[item]
                            }
                        }

                        for(var item in that.final){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.final[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.final[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.final[item] = data[item]
                            }
                        }
                    }
                }
            })
        },
        /**建设工程档案移交书(技术处)**************/
        handleSuccess(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.conproArchive.list.length;i++){
                    if(this.accept.conproArchive.list[i].index==other){
                        this.accept.conproArchive.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel(file,fileList){
            for(var i=0;i<this.accept.conproArchive.list.length;i++){
                if(this.accept.conproArchive.list[i].index==file.index){
                    for(var j=0;j<this.accept.conproArchive.list[i].files.length;j++){
                        if(this.accept.conproArchive.list[i].files[j].uid==file.uid){
                            this.accept.conproArchive.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        // toAdd(){
        //     var length = this.accept.conproArchive.list.length
        //     var ind = this.accept.conproArchive.list[length-1].index
        //     var obj = {
        //         time:'',files:[],index:parseInt(ind)+1
        //     }
        //     this.accept.conproArchive.list.push(obj)
        // },
        // delList(index){
        //     this.accept.conproArchive.list.splice(index,1)
        //     if(this.accept.conproArchive.list.length==0){
        //         var obj = {
        //             index:1,time:'',files:[]
        //         }
        //         this.accept.conproArchive.list.push(obj)
        //     }
        // },
        
        /** 实物移交时间以及移交表*/
        handleSuccess1(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.materialobjectInfo.list.length;i++){
                    if(this.accept.materialobjectInfo.list[i].index==other){
                        this.accept.materialobjectInfo.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file,fileList){
            for(var i=0;i<this.accept.materialobjectInfo.list.length;i++){
                if(this.accept.materialobjectInfo.list[i].index==file.index){
                    for(var j=0;j<this.accept.materialobjectInfo.list[i].files.length;j++){
                        if(this.accept.materialobjectInfo.list[i].files[j].uid==file.uid){
                            this.accept.materialobjectInfo.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd1(){
            var length = this.accept.materialobjectInfo.list.length
            var ind = this.accept.materialobjectInfo.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.materialobjectInfo.list.push(obj)
        },
        delList1(index){
            this.accept.materialobjectInfo.list.splice(index,1)
            if(this.accept.materialobjectInfo.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.materialobjectInfo.list.push(obj)
            }
        },

        /** 国资移交时间及移交表*/
        handleSuccess2(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.wordTrade.list.length;i++){
                    if(this.accept.wordTrade.list[i].index==other){
                        this.accept.wordTrade.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file,fileList){
            for(var i=0;i<this.accept.wordTrade.list.length;i++){
                if(this.accept.wordTrade.list[i].index==file.index){
                    for(var j=0;j<this.accept.wordTrade.list[i].files.length;j++){
                        if(this.accept.wordTrade.list[i].files[j].uid==file.uid){
                            this.accept.wordTrade.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },
        toAdd2(){
            var length = this.accept.wordTrade.list.length
            var ind = this.accept.wordTrade.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.wordTrade.list.push(obj)
        },
        delList2(index){
            this.accept.wordTrade.list.splice(index,1)
            if(this.accept.wordTrade.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.wordTrade.list.push(obj)
            }
        },

        //其他文件上传
        handleSuccess3(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.otherFile.list.length;i++){
                    if(this.accept.otherFile.list[i].index==other){
                        this.accept.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel3(file,fileList){
            for(var i=0;i<this.accept.otherFile.list.length;i++){
                if(this.accept.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.accept.otherFile.list[i].files.length;j++){
                        if(this.accept.otherFile.list[i].files[j].uid==file.uid){
                            this.accept.otherFile.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        //其他添加列表
        toAdd3(){
            var length = this.accept.otherFile.list.length
            var ind = this.accept.otherFile.list[length-1].index
            var obj = {
                val:'',files:[],index:parseInt(ind)+1
            }
            this.accept.otherFile.list.push(obj)
        },
        delList3(index){
            this.accept.otherFile.list.splice(index,1)
            if(this.final.otherFile.list.length==0){
                var obj = {
                    val:'',files:[],index:1
                }
                this.accept.otherFile.list.push(obj)
            }
        },

        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },

        //解析list数据
        filterNull(data){
            var listNull = false
            for(var obj in data[0]){
                if(obj!='index'){
                    if(typeof data[0][obj]=='string' && data[0][obj]!=''){
                        listNull = true
                    }else if(Array.isArray(data[0][obj]) && data[0][obj].length>0){
                        listNull = true
                    }
                }
            }
            if(!listNull){
                data = []
            }
            return data
        },
        //提交
        onFinalSubmit(){
            var data = JSON.parse(JSON.stringify(this.accept))
            // console.log(data)
            var columnName = ''
            for(var item in data){
                for(var obj in data[item]){
                    if(obj=='list' && data[item][obj].length==1){
                        data[item][obj]=this.filterNull(data[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data[item][obj]==''){
                            delete data[item][obj]
                        }
                    }
                }
                if(!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            var data1 = JSON.parse(JSON.stringify(this.final)) //this.final
            delete data1['firstAll']
            delete data1['finalAll']
            for(var item in data1){
                for(var obj in data1[item]){
                    if(obj=='list' && data1[item][obj].length==1){
                        data1[item][obj]=this.filterNull(data1[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data1[item][obj]==''){
                            delete data1[item][obj]
                        }
                    }
                }
                if(!data1[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            //并入集合
            for(var str in data1){
                data[str] = data1[str]
            }
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0',
                entity:JSON.stringify(data),
                updateBy:util.session.get('user').id,
                columnName:columnName,
                type:4
            }
            var that = this
            myHttp.createOrupdateContract(opt).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.getData()
                    that.$store.commit('setRefrshAgree',true)
                    that.$message.success('保存成功');
                }else{
                    that.$message.error(resp.msg);
                }
            })
        },

        /**
         * 决算阶段
         */
        //跟审  final.auditPrice.list
        handleSuccess4(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.auditPrice.list.length;i++){
                    if(this.final.auditPrice.list[i].index==other){
                        this.final.auditPrice.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //添加
        toAuditPrice(){
            var length = this.final.auditPrice.list.length
            var ind = this.final.auditPrice.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.auditPrice.list.push(obj)
        },
        //删除
        delAuditPrice(){
            this.final.auditPrice.list.splice(index,1)
            if(this.final.auditPrice.list.length==0){
                var obj = {
                    index:0,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.auditPrice.list.push(obj)
            }else{
                for(var i=0;i<this.final.auditPrice.list.length;i++){
                    this.final.auditPrice.list[i].index = i
                }
            }
        },
        //初审决算价款及报告 
        handleSuccess5(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.firstAccountinfo.list.length;i++){
                    if(this.final.firstAccountinfo.list[i].index==other){
                        this.final.firstAccountinfo.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel(file,fileList){
            for(var i=0;i<this.final.firstAccountinfo.list.length;i++){
                if(this.final.firstAccountinfo.list[i].index==file.index){
                    for(var j=0;j<this.final.firstAccountinfo.list[i].files.length;j++){
                        this.final.firstAccountinfo.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },
        //添加初审决算价款及报告
        toFirstAccount(){
            var length = this.final.firstAccountinfo.list.length
            var ind = this.final.firstAccountinfo.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.firstAccountinfo.list.push(obj)
        },
        delFirstAccount(index){
            this.final.firstAccountinfo.list.splice(index,1)
            if(this.final.firstAccountinfo.list.length==0){
                var obj = {
                    index:0,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.firstAccountinfo.list.push(obj)
            }else{
                for(var i=0;i<this.final.firstAccountinfo.list.length;i++){
                    this.final.firstAccountinfo.list[i].index = i
                }
            }
        },
        //终审决算价款及报告
        handleSuccess6(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.finalAccountinfo.list.length;i++){
                    if(this.final.finalAccountinfo.list[i].index==other){
                        this.final.finalAccountinfo.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file,fileList){
            for(var i=0;i<this.final.finalAccountinfo.list.length;i++){
                if(this.final.finalAccountinfo.list[i].index==file.index){
                    for(var j=0;j<this.final.finalAccountinfo.list[i].files.length;j++){
                        this.final.finalAccountinfo.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //添加终审决算价款及报告
        toFinalAccount(){
            var length = this.final.firstAccountinfo.list.length
            var ind = this.final.firstAccountinfo.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.firstAccountinfo.list.push(obj)
        },
        delFinalAccount(index){
            this.final.firstAccountinfo.list.splice(index,1)
            if(this.final.firstAccountinfo.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.firstAccountinfo.list.push(obj)
            }
        },
        //其他
        handleSuccess7(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.otherFile.list.length;i++){
                    if(this.final.otherFile.list[i].index==other){
                        this.final.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file,fileList){
            for(var i=0;i<this.final.otherFile.list.length;i++){
                if(this.final.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.final.otherFile.list[i].files.length;j++){
                        this.final.otherFile.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //其他
        toAddOtherFile(){
            var length = this.final.otherFile.list.length
            var ind = this.final.otherFile.list[length-1].index
            var obj = {
                name:'',files:[],index:parseInt(ind)+1
            }
            this.final.otherFile.list.push(obj)
        },
        delOtherFile(index){
            this.final.otherFile.list.splice(index,1)
            if(this.final.otherFile.list.length==0){
                var obj = {
                    name:'',files:[],index:1
                }
                this.final.otherFile.list.push(obj)
            }
        },
        //计算初审
        setFirstTotal(){
            var startAll = 0
            var endAll = 0
            var list = this.final.firstAccountinfo.list
            
            for(var i=0;i<list.length;i++){
                list[i].start = list[i].start==''?0:list[i].start
                list[i].end = list[i].end==''?0:list[i].end
                startAll += parseFloat(list[i].start)
                endAll += parseFloat(list[i].end)
            }
            this.final.firstAll = {
                start:startAll,
                end:endAll
            }
            // console.log(this.final.firstAll)
        },
        //计算
        setFinalTotal(){
            var startAll = 0
            var endAll = 0
            var list = this.final.finalAccountinfo.list
            // console.log(list)
            for(var i=0;i<list.length;i++){
                list[i].start = list[i].start==''?0:list[i].start
                list[i].end = list[i].end==''?0:list[i].end
                startAll += parseFloat(list[i].start)
                endAll += parseFloat(list[i].end)
            }
            this.final.finalAll = {
                start:startAll,
                end:endAll
            }
            // console.log(this.final.finalAll)
        },

    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
        margin-left: 0.5vw;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-form-item__label{
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    /* .bid-box .el-upload-list__item-status-label{
        height: 40px;
        line-height: 40px;
    } */
    .transfer .upload-demo{
        width: 300px;
        max-width: 30%;
    }
    .layui-table td{
        font-size: inherit;
        text-align: center;
        line-height: 30px;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>